// JS Model Props
export interface CheckoutStepModelProps {
	data: Record<string, any>;
}

// API Response Props
// No API props; data stored locally only

// Constructor Props
export type CheckoutStepCtorProps = CheckoutStepModelProps;

export default class CheckoutStep {

	data: Record<string, any>;

	constructor(props: CheckoutStepCtorProps) {
		
		const mappedProps = CheckoutStep.mapDataToModel(props);

		this.data = mappedProps.data;
	}

	// Explicitly map API response to the internal model format
	private static mapDataToModel(props: CheckoutStepCtorProps): CheckoutStepModelProps {
				
		return {
			data: props.data || {},
		};
	}
}